module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_11_22_08_off.3a28eb1f.svg";